export default {
      id: "bottle-usage",
      viewBox: "0 0 160 480",
      url: __webpack_public_path__ + "img/icons.svg#bottle",
      toString: function () {
        return this.url;
      }
    }